"use strict";

var Dropdown = require("app/shared/components/Dropdown/dropdown");

module.exports = React.createClass({
  propTypes: {
    handleChange: React.PropTypes.func.isRequired,
    options: React.PropTypes.array,
    value: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number])
  },
  handleDisplay: function (option) {
    return option.summary;
  },
  render: function() {
    return (
      <div className="w-300">
        <Dropdown
          options={this.props.options}
          handleCustomOptionDisplay={this.handleDisplay}
          handleCustomChange={this.props.handleChange}
          value={this.props.value} />
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./app/screens/Integration/components/GoogleCalendar/calendar-dropdown.jsx